import { useState } from "react";
import { useTimer } from "@/context/TimerContext";
import { fmtClock } from "@/lib/supportApi";
import { TimeEntryDialog } from "@/components/support/TimeEntryDialog";
import { Play, Pause, Stop, Trash, Timer, Plus } from "@phosphor-icons/react";

// Persistent, app-wide timer bar + global quick time-entry launcher (Support orgs only).
export function GlobalTimerBar() {
  const { enabled, timer, displaySeconds, pause, resume, stop, discard } = useTimer();
  const [dlg, setDlg] = useState(null); // 'timer' | 'manual' | null
  if (!enabled) return null;

  return (
    <>
      <div className="fixed bottom-4 left-4 z-40" data-testid="global-timer-bar">
        {timer ? (
          <div className="flex items-center gap-2 rounded-full border border-blue-500/30 bg-zinc-900/95 backdrop-blur px-3 py-2 shadow-xl shadow-black/40">
            <Timer size={18} weight="fill" className={timer.state === "running" ? "text-blue-400 animate-pulse" : "text-amber-400"} />
            <span data-testid="timer-elapsed" className="font-mono text-sm tabular-nums">{fmtClock(displaySeconds)}</span>
            {timer.state === "running" ? (
              <button data-testid="timer-pause-btn" onClick={pause} className="p-1.5 rounded-full hover:bg-white/10" title="Pause"><Pause size={15} weight="fill" /></button>
            ) : (
              <button data-testid="timer-resume-btn" onClick={resume} className="p-1.5 rounded-full hover:bg-white/10" title="Resume"><Play size={15} weight="fill" /></button>
            )}
            <button data-testid="timer-stop-btn" onClick={stop} className="p-1.5 rounded-full hover:bg-emerald-500/20 text-emerald-400" title="Stop & save"><Stop size={15} weight="fill" /></button>
            <button data-testid="timer-discard-btn" onClick={discard} className="p-1.5 rounded-full hover:bg-red-500/20 text-red-400" title="Discard"><Trash size={15} /></button>
          </div>
        ) : (
          <div className="flex items-center gap-1 rounded-full border border-white/10 bg-zinc-900/95 backdrop-blur px-1.5 py-1.5 shadow-xl shadow-black/40">
            <button data-testid="quick-start-timer" onClick={() => setDlg("timer")} className="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full hover:bg-white/10">
              <Timer size={15} weight="fill" className="text-blue-400" /> Start timer
            </button>
            <button data-testid="quick-add-time" onClick={() => setDlg("manual")} className="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full hover:bg-white/10">
              <Plus size={14} weight="bold" /> Add time
            </button>
          </div>
        )}
      </div>
      <TimeEntryDialog open={dlg === "timer"} onOpenChange={(o) => !o && setDlg(null)} mode="timer" />
      <TimeEntryDialog open={dlg === "manual"} onOpenChange={(o) => !o && setDlg(null)} mode="manual" />
    </>
  );
}
